import PropTypes from "prop-types";
import React, { useEffect, useContext, useState } from "react";
import { Link } from "react-router-dom";
import { multilanguage } from "redux-multilanguage";
import { AuthContext } from "../../../common/Auth";
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import RemoveIcon from '@mui/icons-material/Remove';
import { useNavMenuFilter } from "../state/useNavMenuFilter";

const MobileNavMenu = ({ strings, closeMenu }) => {
  const { themeSettingsData, categoriesList, staticPagesList, settingData, user, defaultUserGroup } = useContext(AuthContext)
  const [menuStyle, setMenuStyle] = useState([]);
  const [categoriesData, setcategoriesData] = useState([]);
  const [staticPagesListData, setstaticPagesList] = useState([]);
  const [dynamicmenuData, setDynamicmenuData] = useState([]);
  const [isordermoduleEnabled, setIsordermoduleEnabled] = useState(false);
  const [catMainDropdown, setCatMainDropdown] = useState([]);

  const closeNavMenu = () => {
    setCatMainDropdown([])
    closeMenu()
  }
  const {
    filterMenuItems
  } = useNavMenuFilter({
    user,
    defaultUserGroup
  })


  const menuHandleClick = (id, level) => {
    let tempMenuClicked = [...catMainDropdown];
    if(level === 0) {
      if(catMainDropdown?.[0] === id) {
        tempMenuClicked = [];
      } else {
        tempMenuClicked = [id];
      }
    } else {
      if(catMainDropdown?.[level] === id) {
        tempMenuClicked[level] = null;
      } else {
        tempMenuClicked[level] = id;
      }
      for(let i=level + 1; i<tempMenuClicked.length; i++) {
        tempMenuClicked[i] = null;
      }
    }
    setCatMainDropdown(tempMenuClicked);
  }

  useEffect(() => {
    if (settingData && settingData.length > 0) {
      settingData.map((i) => {
        if (i.page === "General") {
          if (i.values.showOrderModule) {
            setIsordermoduleEnabled(true)
          }
        }
      })
    }
  }, [settingData])
  useEffect(() => {
    if (staticPagesList && staticPagesList.length > 0) {
      let tempData = staticPagesList.filter(staticPage => {
        if (staticPage.isEnabled) {
          if (staticPage.pageLocation === "header") {
            return staticPage
          }
        }
        return false
      })
      setstaticPagesList(tempData)
    }
  }, [staticPagesList])
  useEffect(() => {
    if (themeSettingsData && themeSettingsData.length > 0) {
      themeSettingsData.map((i) => {
        if (i.settingsName === "headerMenu") {
          if (i.values[0].menuItems) {
            const menuItems = filterMenuItems(i.values[0].menuItems)
            setDynamicmenuData(menuItems);
          }
          if (i.values[0].menuSettings) {
            setMenuStyle(i.values[0].menuSettings);
          }
        }
      })
    }
    if (categoriesList && categoriesList.length > 0) {
      setcategoriesData(categoriesList)
    }
  }, [themeSettingsData, categoriesList])
  let menuAnchorStyle = {
    fontFamily: menuStyle.menuFont,
    color: menuStyle.menuFontcolor,
    fontSize: menuStyle.menuFontsize + "px",
  }
  let menuAlignmentStyle = {
    textAlign: menuStyle.menualignment,
  }
  const getUrl = (Link) => {
    const urlregex = new RegExp("^https?:\/\/(.*)");
    if (urlregex.test(Link)) {
      return Link
    }
    Link = Link?.replace(/ /g, "-")?.toLowerCase();
    if (Link && Link !== "" && Link[0] === "/") {
      return Link
    } else {
      return ("/page/" + (Link ? Link : ""))
    }
  }
  const getChildTree = (parentId) => {
    let treeTemp = []
    categoriesList.map(catArray => {
      if (catArray.parent_id === parentId && catArray.isVisibleOnTopMenu) {
        treeTemp.push({ title: catArray.categoryName, url: catArray.ct_slug, expanded: true, id: catArray._id, children: getChildTree(catArray._id) })
      }
    })
    return treeTemp
  }
  let catDataArrange = [];
  if (categoriesList && categoriesList.length > 0) {
    categoriesList.map(catArray => {
      if (catArray.parent_id === "" && catArray.isVisibleOnTopMenu) {
        catDataArrange.push({ title: catArray.categoryName, url: catArray.ct_slug, expanded: true, id: catArray._id, children: getChildTree(catArray._id) })
      }
    })
  }
  const getSubChildMenu = (childCatArray, margineLeft, margineTop, parentCat, childCatTitle) => {
    let menuAnchorStyle1 = {
      fontFamily: childCatArray.fontName,
      color: childCatArray.fontColor,
      fontSize: childCatArray.fontSize + "px",
    }
    let submenuAnchorStyle = {
      fontFamily: childCatArray.subMenufontName,
      color: childCatArray.subMenufontColor,
      fontSize: childCatArray.subMenufontSize + "px",
    }
    if (childCatArray.length === 0) {
      return ""
    } else {
      return <ul key={childCatArray.id} className="sub-menu" style={{ marginLeft: (margineLeft + "%"), marginTop: (margineTop + "px") }}> {childCatArray.map((childCat, index) => {
        return <li key={childCat.id} className="menu-item-has-children">
          <Link to={process.env.PUBLIC_URL + "/products/" + parentCat + '/' + childCatTitle + '/' + childCat.title}
            style={menuAnchorStyle1} onClick={closeNavMenu}>
            {" "}
            {childCat.title} {" "}
          </Link>
        </li>
      })
      }
      </ul>
    }
  }
  const getChildMenu = (childCatArray, parentCat, level) => {
    parentCat = parentCat.replace(/ /g, "-").toLowerCase();

    let menuAnchorStyle1 = {
      fontFamily: childCatArray.fontName,
      color: childCatArray.fontColor,
      fontSize: childCatArray.fontSize + "px",
    }
    if (childCatArray.length === 0) {
      return ""
    } else {
      return <ul key={childCatArray.id} className="sub-menu">
        {childCatArray.map((childCat, index) => {
          return <li key={childCat.id} className={`menu-item-has-children ${catMainDropdown[level] === childCat.id ? "active" : ""}`}>
            <Link to={process.env.PUBLIC_URL + "/products/" + parentCat + '/' + childCat.title.replace(/ /g, "-").toLowerCase() }
              style={menuAnchorStyle1} onClick={closeNavMenu}>
              {" "}
              {childCat.title} {" "}
            </Link>
            {
              childCat.children && childCat.children.length > 0 &&
              <IconButton onClick={() => menuHandleClick(childCat.id, level)} className="more-items" color="primary" aria-label="upload picture" component="span">
                {catMainDropdown[level] !== childCat.id ? <AddIcon /> : <RemoveIcon />}
              </IconButton>
            }
            {getChildMenu(childCat.children, parentCat + '/' + childCat.title, level + 1)}
          </li>
        })}
      </ul>
    }
  }
  const getCategoryManu = (catDataArrange) => {
    if (catDataArrange && catDataArrange.length) {
      
      return catDataArrange.map((category, index) => {
        let dataCategoryData = {}
        if(!!catDataArrange?.menuItemsSetColor) {
          let dataCategory = catDataArrange.menuItemsSetColor.find(res => res.id === category.id)
          if(!!dataCategory) {
            dataCategoryData = dataCategory
          }
        }
        return <li key={category.id}  className={`menu-item-has-children ${catMainDropdown[0] === category.id ? "active" : ""}`}>
          <style>
              {`.cat-menu-items-link-${index}{
                font-family: ${catDataArrange?.fontName};
                font-size: ${catDataArrange?.fontSize + "px"} !important;
                color: ${catDataArrange?.menuFontColor || menuStyle?.menufontcolor} !important;
              }
              .cat-menu-items-link-${index}:hover{
                color: ${menuStyle?.menuHovercolor} !important;
              }`}

              {dataCategoryData && menuStyle.isIndividualColorMenu && `
                .cat-menu-items-link-${index}{
                    background: ${ dataCategoryData?.menuItemBgColor} !important;
                    color : ${ dataCategoryData?.menuItemFontColor} !important;
                    transition: all 0.3s ease 0s
                } 
                .cat-menu-items-link-${index}:hover{
                  background: ${ dataCategoryData?.menuItemBgHoverColor} !important;
                  color : ${ dataCategoryData?.menuItemFontHoverColor} !important;
                }`}
          </style>
          <Link to={process.env.PUBLIC_URL + "/products/" + category.title.replace(/ /g, "-").toLowerCase()}
            className={`cat-menu-items-link-${index}`} onClick={closeNavMenu}>
            {" "}
            {category.title}
          </Link>
          {
            category.children && category.children.length > 0 &&
            <IconButton onClick={() => menuHandleClick(category.id, 0)} className="more-items" color="primary" aria-label="upload picture" component="span">
              {catMainDropdown[0] !== category.id ? <AddIcon /> : <RemoveIcon />}
            </IconButton>
          }
          {getChildMenu(category.children, category.title, 1)}
        </li>
      })
    } else {
      return ""
    }
  }
  return (
    <nav className="offcanvas-navigation" id="offcanvas-navigation">
      <ul style={menuAlignmentStyle}>
        {dynamicmenuData && dynamicmenuData.length > 0 && dynamicmenuData.filter(menu => {
          if (menu.staticName && menu.staticName === "orders") {
            if (isordermoduleEnabled && user) {
              if (menu.isEnabled) {
                return true
              }
            }
            return false
          } else {
            return menu.isEnabled
          }
        }).map((menuArray, index) => {
          let menuAnchorStyle = {
            fontFamily: menuArray.fontName,
            color: menuArray.fontColor,
            fontSize: menuArray.fontSize + "px",
          }
          let submenuBackGroundStyle = {
            backgroundColor: menuArray.subMenuBackgroundColor ? menuArray.subMenuBackgroundColor : "",
          }
          let submenuAnchorStyle = {
            fontFamily: menuArray.subMenufontName,
            color: menuArray.subMenufontColor,
            fontSize: menuArray.subMenufontSize + "px",
          }
          if (menuArray.staticName && menuArray.staticName === "staticPage" && menuArray.isEnabled) {
            return staticPagesListData && staticPagesListData.length > 0 && 
            <li className={`menu-item-has-children ${catMainDropdown[0] === menuArray.id ? "active" : ""}`} key={"li" + index}>
              <style>
                {`.menu-items-link-${index}{
                  font-family: ${menuArray?.fontName};
                  font-size: ${menuArray?.fontSize + "px"} !important;
                  color: ${menuArray?.menuFontColor || menuStyle?.menufontcolor} !important;
                }
                .menu-items-link-${index}:hover{
                  color: ${menuStyle?.menuHovercolor} !important;
                }`}

                {menuStyle && menuStyle.isIndividualColorMenu && `
                  .menu-items-link-${index}{
                      background: ${menuArray?.menuItemBgColor} !important;
                      color : ${menuArray?.menuItemFontColor} !important;
                      transition: all 0.3s ease 0s
                  } 
                  .menu-items-link-${index}:hover{
                    background: ${menuArray?.menuItemBgHoverColor} !important;
                    color : ${menuArray?.menuItemFontHoverColor} !important;
                  }`}
              </style>
              <a href={process.env.PUBLIC_URL + getUrl(menuArray.anchorLink)}
              className={`menu-items-link-${index}`}
                // style={menuAnchorStyle} 
                onClick={closeNavMenu}>
                {menuArray.name}
              </a>
              {
                staticPagesListData && staticPagesListData.length > 0 &&
                <IconButton onClick={() => menuHandleClick(menuArray.id, 0)}  className="more-items" color="primary" aria-label="upload picture" component="span">
                  {catMainDropdown[0] !== menuArray.id ? <AddIcon /> : <RemoveIcon />}
                </IconButton>
              }
              <ul className="sub-menu" style={{ backgroundColor: menuArray.subMenuBackgroundColor ? menuArray.subMenuBackgroundColor : "" }}>
                {staticPagesListData && staticPagesListData.length > 0 && staticPagesListData.filter(staticPage => !staticPage.isBreakoutHtml).map((staticPage, index) => {
                  return <li key={index}><a href={getUrl(staticPage.pageLink)}
                    style={submenuAnchorStyle}>
                    {staticPage.pageName}
                  </a></li>
                })}
              </ul>
            </li>
          }
          if (menuArray.staticName && menuArray.staticName === "categories" && menuArray.isEnabled) {
            return getCategoryManu(catDataArrange)
          }
          return <li key={"menu-item"+index} className={`menu-item-has-children ${catMainDropdown[0] === menuArray.id ? "active" : ""}`}>
            <style>
              {`.menu-items-link-${index}{
                  font-family: ${menuArray?.fontName};
                  font-size: ${menuArray?.fontSize + "px"} !important;
                  color: ${menuArray?.menuFontColor || menuStyle?.menufontcolor} !important;
                }
                .menu-items-link-${index}:hover{
                  color: ${menuStyle?.menuHovercolor} !important;
                }`}

              {menuStyle && menuStyle.isIndividualColorMenu && `
                .menu-items-link-${index}{
                    background: ${menuArray?.menuItemBgColor} !important;
                    color : ${menuArray?.menuItemFontColor} !important;
                    transition: all 0.3s ease 0s
                } 
                .menu-items-link-${index}:hover{
                  background: ${menuArray?.menuItemBgHoverColor} !important;
                  color : ${menuArray?.menuItemFontHoverColor} !important;
                }`}
            </style>
            <a href={process.env.PUBLIC_URL + getUrl(menuArray.anchorLink)}
            className={`menu-items-link-${index}`}
              // style={menuAnchorStyle} 
              onClick={closeNavMenu}
            > {menuArray.name}</a>
            {
              menuArray?.submegaMenuitems && menuArray?.submegaMenuitems?.menuItemsLi && menuArray.submegaMenuitems.menuItemsLi.length > 0 &&
              <IconButton onClick={() => menuHandleClick(menuArray.id, 0)} className="more-items" color="primary" aria-label="upload picture" component="span">
                {catMainDropdown[0] !== menuArray.id ? <AddIcon /> : <RemoveIcon />}
              </IconButton>
            }
            {
              menuArray?.subMenus && menuArray?.subMenuitems && menuArray.subMenuitems.length > 0 &&
              <IconButton onClick={() => menuHandleClick(menuArray.id, 0)} className="more-items" color="primary" aria-label="upload picture" component="span">
                {catMainDropdown[0] !== menuArray.id ? <AddIcon /> : <RemoveIcon />}
              </IconButton>
            }
            {menuArray.isSubmenu && <>
              {menuArray.subMegaMenu && menuArray.submegaMenuitems &&
                <ul className="sub-menu" style={submenuBackGroundStyle}>
                  {menuArray.submegaMenuitems.imageList && menuArray.submegaMenuitems.imageList.length > 0 && menuArray.submegaMenuitems.imageList.map((menuItemArray, menuKey) => {
                    return <li key={index + "sibmenuitem" + menuKey}  >
                      <a
                        style={submenuAnchorStyle}
                        href={getUrl(menuItemArray.anchorLink)}>
                        {menuItemArray.title}
                      </a>
                    </li>
                  })}
                  {menuArray.submegaMenuitems.menuItemsLi && menuArray.submegaMenuitems.menuItemsLi.length > 0 && menuArray.submegaMenuitems.menuItemsLi.map((menuItemArray, menuKey) => {
                    return <li key={index + "sibmenuitem" + menuKey}  >
                      <ul style={submenuBackGroundStyle} className="pr-2">
                        {menuItemArray.items && menuItemArray.items.length > 0 && menuItemArray.items.map((item, itemKey) => {
                          return <li key={index + "img" + itemKey}>
                            <a
                              style={submenuAnchorStyle}
                              href={getUrl(item.anchorLink)}>
                              {item.name}
                            </a>
                          </li>
                        })}
                      </ul>
                    </li>
                  })}
                </ul>
              }
            </>}
            {menuArray.subMenus && menuArray.subMenuitems && menuArray.subMenuitems.length > 0 && <>
              <ul className="sub-menu" style={submenuBackGroundStyle}>
                {menuArray.subMenuitems.map((subMenuArray, subIndex) => {
                  return <li key={subIndex}>
                    <a href={subMenuArray.anchorLink ? subMenuArray.anchorLink : ""}
                      style={submenuAnchorStyle}>
                      {subMenuArray.name}
                    </a>
                  </li>
                })}
              </ul>
            </>}
          </li>
        })}
      </ul>
    </nav>
  );
};
MobileNavMenu.propTypes = {
  strings: PropTypes.object
};
export default multilanguage(MobileNavMenu);
